var Dlrt;
(function (Dlrt) {
    Dlrt.removeDiacritics = (s) => s ? s.normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'g'), '') : s;
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=StringHelpers.js.map
